/**
 * Чистая логика черновика суммы для numpad-компонента PlanPad.
 * Черновик — строка цифр, '' допустимо (означает 0 при отображении).
 */

const PLAN_FMT = new Intl.NumberFormat('ru-RU');

/**
 * Нажатие клавиши numpad.
 * key: '0', '1'…'9', '00' — добавляет в конец строки; нецифровой key — без изменений.
 * Ведущий ноль не копится: строка из одних нулей нормализуется в '0'.
 * Максимум 9 цифр (обрезка slice). Результат никогда не содержит ведущих нулей
 * перед значащими цифрами и не бывает '00', '000' и т.п. — только '0'.
 */
export function pressPlanKey(draft: string, key: string): string {
  if (!/^\d+$/.test(key)) return draft;
  const base = draft === '0' ? '' : draft;
  const raw = (base + key).slice(0, 9);
  // Строка из одних нулей → '0'; убирает '00', '000' и ведущие нули перед значащей цифрой.
  return raw.replace(/^0+(\d)/, '$1').replace(/^0+$/, '0');
}

/** Убрать последний символ черновика (backspace). */
export function erasePlanKey(draft: string): string {
  return draft.slice(0, -1);
}

/** '' → 0, иначе Number. */
export function planDraftValue(draft: string): number {
  return draft === '' ? 0 : Number(draft);
}

/** Формат ru-RU с группировкой: 24000 → «24 000». */
export function fmtPlanNum(n: number): string {
  return PLAN_FMT.format(n);
}
